import { render, staticRenderFns } from "./SidebarRegister.vue?vue&type=template&id=a5b0eee8&"
import script from "./SidebarRegister.vue?vue&type=script&lang=js&"
export * from "./SidebarRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports